<template>
  <div id="artist-submissions">
    <div id="hero">
      <div class="container">
        <div class="columns is-vcentered">
          <div class="column is-10 is-offset-1 has-text-centered">
            <h1 class="title-wide is-0 text color-white mb-4">
              Artists: Be part of the future
            </h1>
            <br>
            <p class="text extra-large color-white mb-5 px-6">
              We've built a platform to connect independent artists to todays filmmakers and content creators.
            </p>
            <br>
            <div class="button-row">
              <a
                class="button is-secondary is-large is-rounded ghost-inverse"
                href="https://s.disco.ac/omrhcywnwlyw"
              >Apply today</a>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <section class="has-text-centered">
        <h2 class="title is-2">
          Want your music on TV, film and more?
        </h2>
        <br>
        <ul>
          <li class="title is-3">
            Retain 100% of your rights
          </li>
          <li class="title is-3">
            Get paid quickly
          </li>
          <li class="title is-3">
            No strings attached
          </li>
        </ul>
      </section>
      <section>
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <h2 class="title is-2">
              The <span class="has-text-weight-bold">
                Sonata</span> story
            </h2>

            <p class="text xl">
              Sonata was born out of an existing music agency, here in London, <a href="https://soundscapeagency.com/">Soundscape</a>.
              We've been scoring and licensing music for film and brands for over 15 years.
              As a collective of musicians, filmmakers and creatives we've been frustrated
              by the inner workings of the music licensing sector. The lack of transparency,
              promotion of average stock music and shady rights management which all
              inevitably leads to the right music not being placed on the right projects.
              Artists are frustrated and so are the end users, filmmakers. We want to simplify
              the licensing engine for all parties, once and for all.
            </p>
            <br>
            <p class="text xl">
              Our goal is to give phenomenal independent artists and composers some well-deserved
              reach and help carry your music as far as it can possibly go through the power of
              the sync license. At the same time, we've developed a model that makes licensing
              this music fluid, affordable, fast, accessible and transparent so that our end
              users keep coming back and the artistry is valued - properly.
            </p>
            <br>
            <p class="text xl">
              All of this has formed the foundations to set up our new venture, Sonata, with a
              dedicated team of specialists to build out our vision and leverage our existing
              contacts.
            </p>
            <br>
            <br>
            <p class="has-text-centered">
              <a
                class="button is-large is-rounded"
                href="https://soundscapeagency.com/"
              >Lean more about Soundscape</a>
            </p>
          </div>
        </div>
      </section>
      <section>
        <div class="columns">
          <div class="column">
            <figure>
              <img src="@/assets/community.jpg">
            </figure>
            <br>
            <p class="text xl">
              Sonata is a community of composers, producers and artists that bring their music to the catalog and offer a license to use their work in video, film and content productions. We connect this platform to a network of professional freelancers and media organisations that access our catalog by paying for an annual subscription or single-use licenses depending on how they plan to use the music.
            </p>
          </div>
          <div class="column">
            <figure>
              <img src="@/assets/revenue.jpg">
            </figure>
            <br>
            <p class="text xl">
              Sonata's music is available to license either via a traditional single-use license or a subscription model (for our frequent users). We split all revenue with you, our artists, 50-50. The single license model works as standard. The revenue generated from subscription fees is collected and divided amongst artists according to their percentage of overall downloads. Artists do not pay to be part of SONATA but not all applications are accepted and subject to our A&amp;R process.
            </p>
          </div>
          <div class="column">
            <figure>
              <img src="@/assets/ownership.jpg">
            </figure>
            <br>
            <p class="text xl">
              We do not ask for any exclusivity and artists keep 100% ownership of their music. This means you will retain 100% of your publishing royalties from sync placements. You're free to come and go as you please, allowing you to keep control over your music &amp; career. There genuinely are no strings attached.
            </p>
          </div>
        </div>
      </section>
      <section>
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <h2 class="title is-2">
              Designed for artists and score composers
            </h2>

            <p class="text xl">
              In our experience, all music, whatever the style or nature will be relevant for someone, somewhere. However there are a number of genres and styles that just seem to get more sync placements than others. That's not to say if you don't fit one of the criteria below you shouldn't submit, we're just giving you some pointers:
            </p>
            <br>
            <ul>
              <li>Cinematic</li>
              <li>Electronic</li>
              <li>Singer-Songwriter</li>
              <li>Soul</li>
              <li>Blues</li>
              <li>Urban</li>

              <li>Indie</li>
              <li>Country</li>
              <li>World</li>
              <li>Ambient Soundscapes &amp; Beds</li>
              <li>Jazz</li>
              <li>Pop</li>
            </ul>
            <br>
            <p class="text xl">
              To be clear, Sonata is not another "stock" library. Our model allows you, the artists and composers to retain 100% of your rights whilst showcasing your music to industry movers and shakers. Therefore we're only accepting tracks of a high production standard, so please, submit your best for review.
            </p>
            <br>
            <br>
            <p class="has-text-centered">
              <a
                class="button is-large is-rounded"
                href="https://soundscapeagency.com/"
              >Lean more about Soundscape</a>
            </p>
          </div>
        </div>
      </section>
      <section>
        <div class="columns">
          <div class="column is-8">
            <p class="is-size-2">
              "Sync licensing is becoming an increasingly important revenue source for todays artists. SONATA has found a smart solution to bridge the gap and support emerging talent whilst providing a better service for todays content industry."
            </p>
            <br>
            &mdash;JONO DAS, MUSIC PRODUCER & CREATIVE DIRECTOR AT KMG
          </div>
        </div>
      </section>
      <section>
        <div class="columns">
          <div class="column is-8 is-offset-2">
            <h2 class="title is-2">
              Submission details
            </h2>

            <p class="text xl">
              Now you know the details, it's time to apply. Please see below for 3 steps to submission heaven:
            </p>
            <br>
            <ol>
              <li>
                <p class="text xl">
                  Please apply through our submissions portal below.
                </p>
              </li>
              <li>
                <p class="text xl">
                  Our A&amp;R team will review all applications and respond within 14 days.
                </p>
              </li>
              <li>
                <p class="text xl">
                  If approved we'll request further details to and arrange contracts.
                </p>
              </li>
            </ol>
            <br>
            <br>
            <p class="has-text-centered">
              <a
                class="button is-primary is-large is-rounded"
                href="https://s.disco.ac/omrhcywnwlyw"
              >Apply today</a>
            </p>
          </div>
        </div>
      </section>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ArtistSubmissions',

  metaInfo: {
    title: 'Become a Sonata artist | Music Licensing'
  }
}
</script>

<style scoped lang="scss">
section {
  margin-top: 0;
}
ul li {
  list-style: disc;
}
</style>
